export const probeMutedAudioPlayback = async (
  audio: HTMLAudioElement
): Promise<boolean> => {
  try {
    await audio.play()
    audio.pause()
    audio.currentTime = 0
    return true
  } catch {
    return false
  }
}
